import type { TFunction } from 'i18next'
import type { ReactNode } from 'react'

export type InfoEntry = {
  entryId: string
  title: string
  value: string | undefined
  displayValue?: ReactNode
}

export type InfoGroup = {
  groupId: string
  title: string
  entries: InfoEntry[]
}

export function joinInfoGroups(infoGroups: InfoGroup[], t: TFunction<'shared'>): string {
  return infoGroups
    .map(({ title, entries }) => {
      return `# ${title}:\n${entries.map(({ title, value }) => `${title}:\t${value || t('common.label.not-available-short')}`).join('\n')}`
    })
    .join('\n\n')
}
